import {AxiosInstance} from "axios";
import QuotePreview from "../model/quote/QuotePreview";
import {QuoteApiDto} from "./model/rest";
import Quote from "../model/quote/Quote";
import QuoteDetails from "../model/quote/QuoteDetails";

/**
 * Api for quotes.
 */
export default class QuoteApi {
	constructor(public readonly axiosInstance: AxiosInstance) {}

	/**
	 * Create quote (will be changed)
	 * @param {Quote} quote
	 * @returns {Promise<QuotePreview>}
	 */
	createQuote(quote: Quote): Promise<any> {
		const url = `/api/web/leads/${quote.leadId.getOrElse("-1")}/quotes`;
		return this.axiosInstance.post(url, quote.toJsonCreateDto())
	}

	/**
	 * Attach attachments to quote
	 * @param {string} leadId
	 * @param {string} quoteId
	 * @param {string[]} attachmentIds
	 * @returns {Promise<any>}
	 */
	attachUploadedFiles(leadId: string, quoteId: string, attachmentIds: string[]): Promise<any> {
		const url = `/api/web/leads/${leadId}/quotes/${quoteId}/attachments`;
		return this.axiosInstance.post(url, {ids: attachmentIds});
	}

	/**
	 * Fetch quotes preview for lead
	 * @param {string} leadId
	 * @returns {Promise<QuotePreview[]>}
	 */
	fetchQuotes(leadId: string): Promise<QuotePreview[]> {
		const url = `/api/web/leads/${leadId}/quotes`;
		return this.axiosInstance.get(url).then(resp => {
			const data: QuoteApiDto[] = resp.data;
			return data.map(q => QuotePreview.fromJson(q, leadId))
		});
	}

	/**
	 * Submit quote related rewards points action
	 */
	submitRewardPoints(quoteId: string): Promise<any> {
		const url = `/api/web/leads/quotes/${quoteId}/points/submit`;
		return this.axiosInstance.put(url);
	}

	/**
	 * Sends data for quote email preview.
	 * @param quoteId Quote id
	 * @param subject Email subject.
	 * @param content Email content (html format).
	 */
	sendQuoteEmailPreview(quoteId: string, subject: string, content: string) {
		const url = `/api/web/leads/quotes/${quoteId}/email_preview`;
		const config = {subject, content};
		return this.axiosInstance.put(url, config)
	}

	/**
	 * Send data for quote email.
	 * @param quoteId Quote id
	 * @param subject Email subject.
	 * @param content Email content (html format).
	 */
	sendQuoteEmail(quoteId: string, subject: string, content: string) {
		const url = `/api/web/leads/quotes/${quoteId}/email`;
		const config = {subject, content};
		return this.axiosInstance.put(url, config)
	}

	/**
	 * Get quote details
	 * @param quoteId
	 * @param versionNumber
	 */
	fetchQuoteDetails(quoteId: string, versionNumber?: number): Promise<QuoteDetails> {
		const url = `/api/web/leads/quotes/${quoteId}/details`;
		return this.axiosInstance.get(url, {params: {versionNumber}}).then(resp => QuoteDetails.fromJson(resp.data));
	}

	/**
	 * Updates quote finance product.
	 * @param quoteId
	 * @param financeProductId
	 */
	updateQuoteFinanceProduct(quoteId: string, financeProductId: string) {
		const url = `/api/web/leads/quotes/${quoteId}/finance_product`;
		return this.axiosInstance.put(url, {financeProductId});
	}
}